module.exports = require('../../vendor/names.json')
